export default __webpack_public_path__ + "static/media/clouds.6e9e6e5f.svg";